import React, { useEffect, useState } from "react";
import Header from "../../shared/ArtistHeader/header";
import Footer from "../../shared/footer/footer";
import Checkout from "./../../components/artist/purchase/checkout";
import { useLocation } from "react-router";

const ArtistRegister = () => {
	const location = useLocation();

	const [state, setState] = useState({
		imagePath: "",
		size: 0,
		screen: 0,
		// type:null,
		elem: {},
		// index:null
	});

	useEffect(() => {
		if (!location.state || !sessionStorage.getItem("album_id")) {
			const pathArray = window.location.href.split("/");
			const protocol = pathArray[0];
			const host = pathArray[2];
			const url = protocol + "//" + host;
			window.location = url + "/artist/dashboard";
		}
	}, []);

	return (
		<div>
			<Header />
			<section id="content" className="pt50">
				<Checkout albumData={location.state.data} />
			</section>
			<Footer />
		</div>
	);
};

export default ArtistRegister;
